type CaptureMessageLevel = 'info' | 'warning' | 'error';

interface CaptureMessageContext {
  readonly level: CaptureMessageLevel;
  readonly extra: Record<string, unknown> | undefined;
  readonly fingerprint: string[];
}

// Sentry groups on the top in-app frame, which for a captured message is always
// the logger wrapper, so without an explicit fingerprint every message in the
// app collapses into a single issue.
//
// Kept apart from sentryLogger so it can be tested without pulling the Sentry
// SDK, and react-native with it, into the module graph.
const buildCaptureMessageContext = (
  message: string,
  level: CaptureMessageLevel,
  context?: Record<string, unknown>,
): CaptureMessageContext => ({
  level,
  extra: context,
  fingerprint: [message],
});

export { buildCaptureMessageContext };
export type { CaptureMessageContext, CaptureMessageLevel };
